// import Vue from 'vue';
// import Vuetify from 'vuetify/lib';

// Vue.use(Vuetify);

// export default new Vuetify({
// });

import Vue from 'vue'
// import Vuetify, {
//     VApp,
//     VD,
//     VCard,
//     VRating,
//     VToolbar,
//     VList,
// } from 'vuetify/lib'
// import { Ripple } from 'vuetify/lib/directives'

import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'

import GoogleIcon from '@/auth/google-logo.vue'

Vue.use(Vuetify, {
  // components: {
  //     VApp,
  //     VNa,
  //     VCard,
  //     VRating,
  //     VToolbar,
  //     VList,
  // },
  // directives: {
  //     Ripple
  // }
})

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    values: {
      google: { // name of our custom icon
        component: GoogleIcon // our custom component
      }
    }
  },
  theme: {
    themes: {
      light: {
        primary: '#ee44aa',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        primary: colors.orange.darken1,
        secondary: colors.blue.base,
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        darkBlack: '#1f1e31', //'#121212'
        lightBlack: '#a0aec0' //
      }
    }
  }
})
